import { AttributeLabelDetailsState } from "@idw-types/state/attribute-label-details-state";
import { AttributeLabelDetailsActionTypes, AttributeLabelDetailsActions } from "../actions/attribute-label-details-actions";

export const initialAttributeLabelDetailsState: AttributeLabelDetailsState = {
    attributeLabel: {
        isLoading: false,
        attributeLabel: null
    }
};

export const attributeLabelDetailsReducer = (
    state: AttributeLabelDetailsState = initialAttributeLabelDetailsState,
    action: AttributeLabelDetailsActions
): AttributeLabelDetailsState => {
    switch (action.type) {
        // Attribute Label Details
        case AttributeLabelDetailsActionTypes.SET_ATTRIBUTE_LABEL_DETAILS_LOADING:
            return {
                ...state,
                attributeLabel: {
                    ...(action.payload.isLoading
                        ? { ...initialAttributeLabelDetailsState.attributeLabel }
                        : { ...state.attributeLabel }),
                    isLoading: action.payload.isLoading
                }
            };
        case AttributeLabelDetailsActionTypes.SET_ATTRIBUTE_LABEL_DETAILS:
            return {
                ...state,
                attributeLabel: {
                    attributeLabel: action.payload.axnAttributeLabel,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};